<template>
  <img src="~/assets/icons/icon.svg" alt="Logo" class="w-24 lg:w-48" />
</template>
